import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-line-chart",
  "use": "icon-line-chart-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-line-chart\"><path fill=\"none\" stroke=\"currentColor\" d=\"M1 13h14M2 4l3-2 3 4 2-2 4 5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol